import React from 'react'
import { Badge, Grid, Group, Stack, Text } from '@mantine/core'
import dayjs from 'dayjs'
import { RelatedCompanyItem } from './types'
import { useTheme } from '../../../components/ThemeProvider'

interface RelatedCompanyCardProps {
  company: RelatedCompanyItem
}

const RelatedCompanyCard: React.FC<RelatedCompanyCardProps> = ({ company }) => {
  const theme = useTheme()

  const formatDate = (dateStr: string) => {
    if (!dateStr) return '-'
    return dayjs(dateStr).format('YYYY-MM-DD')
  }

  const getStatusColor = (status: string) => {
    switch (status) {
      case '存续':
        return 'green'
      case '注销':
        return 'red'
      case '吊销':
        return 'orange'
      default:
        return 'gray'
    }
  }

  const getMatchTypeColor = (matchType: string) => {
    if (matchType.includes('法定代表人')) return 'blue'
    if (matchType.includes('股东')) return 'purple'
    if (matchType.includes('高管')) return 'cyan'
    if (matchType.includes('公司名称')) return 'orange'
    return 'gray'
  }

  return (
    <Stack gap="sm">
      <Group justify="space-between" align="flex-start">
        <Stack gap="xs" style={{ flex: 1 }}>
          <Group gap="sm" align="center">
            <Text size="sm" fw={600} style={{ color: theme?.primaryColor || '#1c7ed6' }}>
              {company.name}
            </Text>
            <Badge color={getStatusColor(company.regStatus)} variant="light" size="sm">
              {company.regStatus}
            </Badge>
            <Badge color={getMatchTypeColor(company.matchType)} variant="light" size="sm">
              {company.matchType}
            </Badge>
          </Group>

          <Grid gutter="xs">
            <Grid.Col span={6}>
              <Text size="xs" c="dimmed">
                统一社会信用代码
              </Text>
              <Text size="xs">{company.creditCode}</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="xs" c="dimmed">
                法定代表人
              </Text>
              <Text size="xs">{company.legalPersonName}</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="xs" c="dimmed">
                注册资本
              </Text>
              <Text size="xs">{company.regCapital}</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="xs" c="dimmed">
                成立时间
              </Text>
              <Text size="xs">{formatDate(company.estiblishTime)}</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="xs" c="dimmed">
                注册号
              </Text>
              <Text size="xs">{company.regNumber}</Text>
            </Grid.Col>
            <Grid.Col span={6}>
              <Text size="xs" c="dimmed">
                所属地区
              </Text>
              <Text size="xs">{company.base}</Text>
            </Grid.Col>
          </Grid>
        </Stack>
      </Group>
    </Stack>
  )
}

export default RelatedCompanyCard
